import { VENDOR_OPPORTUNITIES_REVENUE } from './vendorOpportunitiesRevenue';

export const financeListApi = {
  vendorOpportunitiesRevenue: VENDOR_OPPORTUNITIES_REVENUE,
};
